import React from "react";
import "./module.css";

const TermsConditions = () => {
  return (
    <>
      <div class="wrap">
        <div class="card">
          <header>
            <div class="logo">MG</div>
            <div>
              <h1>MyNetGoals — Terms and Conditions</h1>
              <div class="meta">Last updated: November 10, 2025</div>
            </div>
          </header>

          <section>
            <p>
              Welcome to <strong>MyNetGoals</strong> ("we", "our", "us"). These
              Terms and Conditions ("Terms") govern your access to and use of
              the MyNetGoals website, mobile application, and related services
              (collectively, the "Platform"). By creating an account or using
              the Platform, you agree to comply with and be bound by these
              Terms. If you do not agree, please do not use MyNetGoals.
            </p>

            <h2>1. Eligibility</h2>
            <ul>
              <li>
                You must be at least 13 years of age (or the minimum age
                required by your country) to use the Platform.
              </li>
              <li>You must have legal capacity to enter into these Terms.</li>
              <li>
                You agree to provide accurate and complete information during
                registration.
              </li>
            </ul>

            <h2>2. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activity that occurs under your
              account. Do not share your password. Notify us immediately at{" "}
              <a href="mailto:support@mynetgoals.com">support@mynetgoals.com</a>{" "}
              if you suspect unauthorized access.
            </p>

            <h2>3. Uploading Content (Goals and Videos)</h2>
            <p>
              You may upload football goal videos and related User Content
              through the app or website. By uploading, you represent and
              warrant that you own or have the necessary rights to the content
              and that your content does not violate any laws or third-party
              rights.
            </p>
            <p>Prohibited content includes, but is not limited to:</p>
            <ul>
              <li>Copyrighted material without permission</li>
              <li>Sexual, violent, hateful, or discriminatory content</li>
              <li>Spam, misleading information, or malicious content</li>
            </ul>
            <p>
              By uploading User Content you grant MyNetGoals a non-exclusive,
              worldwide, royalty-free license to host, display, distribute, and
              promote your content on the Platform. You retain ownership of your
              content.
            </p>

            <h2>4. Tournaments and Invitations</h2>
            <p>
              The Platform allows users to create and manage football
              tournaments and invite other users by phone number, email, or
              in-app sharing. You agree to invite only people you are permitted
              to contact and not to use the invitation features for spam or
              harassment. Misuse may lead to account suspension.
            </p>

            <h2>5. Acceptable Use</h2>
            <p>
              You agree not to use the Platform for unlawful activities,
              hacking, reverse-engineering, sending malicious code, or
              impersonation. We reserve the right to remove content or suspend
              accounts that violate these Terms.
            </p>

            <h2>6. Privacy</h2>
            <p>
              Your privacy is important to us. Our{" "}
              <a href="/privacy">Privacy Policy</a> explains how we collect and
              use your personal data, including phone numbers and emails you
              supply for invites.
            </p>

            <h2>7. Intellectual Property</h2>
            <p>
              All trademarks, logos, designs, and software on the Platform are
              the property of MyNetGoals Technologies or its licensors. You may
              not copy, modify, or redistribute any Platform content without
              prior written consent.
            </p>

            <h2>8. Payment and Fees (if applicable)</h2>
            <p>
              If the Platform offers paid services (tournament entry fees,
              premium features), those terms will be presented separately. You
              are responsible for all applicable fees and taxes. Refund policies
              will be described where payments are collected.
            </p>

            <h2>9. Termination</h2>
            <p>
              We may suspend or terminate your account if you violate these
              Terms, engage in fraudulent behavior, or if required by law. Upon
              termination, your access to the Platform and stored data may be
              revoked.
            </p>

            <h2>10. Disclaimers</h2>
            <p>
              The Platform is provided "as is" and "as available". We do not
              guarantee uninterrupted or error-free operation. We are not
              responsible for user-generated content or third-party services
              linked from the Platform.
            </p>

            <h2>11. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, MyNetGoals and its
              affiliates will not be liable for indirect, incidental, or
              consequential damages arising from your use of the Platform.
            </p>

            <h2>12. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. The latest version
              will be posted at{" "}
              <a href="https://mynetgoals.com/terms">
                https://mynetgoals.com/terms
              </a>
              . Continued use after changes indicates acceptance of the updated
              Terms.
            </p>

            <h2>13. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the jurisdiction in which
              MyNetGoals Technologies is incorporated, unless otherwise required
              by local law. Any disputes will be resolved in the appropriate
              courts for that jurisdiction.
            </p>

            <h2>14. Contact Us</h2>
            <p>If you have questions about these Terms, contact us at:</p>
            <p class="small">
              Email:{" "}
              <a href="mailto:support@mynetgoals.com">support@mynetgoals.com</a>
              <br />
              Website:{" "}
              <a href="https://mynetgoals.com">https://mynetgoals.com</a>
            </p>

            <footer>
              <p class="small">
                © MyNetGoals Technologies — All rights reserved.
              </p>
            </footer>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
